export default __webpack_public_path__ + "static/media/logo.b13bed87.png";